var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6DCC6A",
    d: "M6,21 C2.6862915,21 0,18.3137085 0,15 C0,12.0057965 2.19324506,9.52385285 5.06082914,9.07307506 C5.51432189,5.64522746 8.44824796,3 12,3 C15.551752,3 18.4856781,5.64522746 18.9391709,9.07307506 C21.8067549,9.52385285 24,12.0057965 24,15 C24,18.3137085 21.3137085,21 18,21 L6,21 Z M10.6883726,14.3252358 L8.28234139,11.8235294 L7,13.1568627 L9.5651074,15.8230879 L10.680697,17 L17,10.3333333 L15.7361394,9 L10.6883726,14.3252358 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSuccess);
export default __webpack_public_path__ + "static/media/CloudSuccess.00c42ee5.svg";
export { ForwardRef as ReactComponent };